// Angular
import { Injectable } from "@angular/core"
import { Router } from "@angular/router"
// Lodash
import { merge } from "lodash"
// Object-Path
import * as objectPath from "object-path"
// RxJS
import { Subject } from "rxjs"

@Injectable()
export class PageConfigService {
	// Public properties
	onConfigUpdated$: Subject<any>
	pageConfig: any

	/**
	 * Service Constructor
	 *
	 * @param router: Router
	 */
	constructor(private router: Router) {
		// register on config changed event and set default config
		this.onConfigUpdated$ = new Subject()
	}

	/**
	 * Get current page config based on route
	 */
	getCurrentPageConfig(path?: string): any {
		let url = this.router.url

		// remove first route (demo name) from url router
		//console.log('getCurrentPageConfig path',url)
		if (new RegExp(/^\/home/).test(url)) {
			const urls = url.split("/")
			urls.splice(0, 2)
			if (objectPath.get(this.pageConfig, urls[0])) {
				var childPageConfig = objectPath.get(this.pageConfig, urls[0])
				if (childPageConfig["any"] && urls[1]) urls[1] = "any"
				if (childPageConfig["any"] && urls[2]) urls[2] = "any"
				if (childPageConfig["any"] && urls[3]) urls[3] = "any"
				
			}
			url = urls.join("/")
			//console.log('path url',url,this.pageConfig,childPageConfig)
		}

		if (url.charAt(0) == "/") {
			url = url.substring(1)
		}

		let configPath = url.replace(/\//g, ".")

		if (path) {
			configPath += "." + path
		}

		// get page config by path
		return objectPath.get(this.pageConfig, configPath)
	}

	/**
	 * Set existing config with a new value
	 * @param value: any
	 * @param save: boolean?
	 */
	setConfig(value: any, save?: boolean): void {
		this.pageConfig = merge(this.pageConfig, value)

		if (save) {
			// not implemented
		}

		// fire off an event that all subscribers will listen
		this.onConfigUpdated$.next(this.pageConfig)
	}

	/**
	 * Load confgis
	 *
	 * @param config: any
	 */
	loadConfigs(config: any) {
		this.pageConfig = config
		this.onConfigUpdated$.next(this.pageConfig)
	}
}
